module.exports = __webpack_public_path__ + "img/code-obg-test.49239177.png";